import { Box, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'src/store/store';
import { Link } from 'react-router-dom';

interface Props {
  type: 'disaster' | 'holiday' | 'payment_failed' | 'invalid_method';
  onClose: () => void;
}

export const Banner: React.FC<Props> = ({ type, onClose }) => {
  const isAdmin = useSelector((state: RootState) => state.user.currentUser.role) === 'admin';
  const [isClosed, setIsClosed] = useState(false);
  const bgColorByType = {
    disaster: '#FFE8E7',
    holiday: '#CEE2FF',
    payment_failed: '#FFE8E7',
    invalid_method: '#FFE8E7',
  };

  const colorByType = {
    disaster: '#AC3737',
    holiday: '#0A0C2F',
    payment_failed: '#AC3737',
    invalid_method: '#AC3737',
  };

  const textByType = {
    disaster: () => [
      'Due to unforeseen circumstances, we are temporarily routing jobs through our backup mailing facility. As we work diligently to restore normal service levels, please allow up to 48 hours for job fulfillment.',
    ],
    holiday: () => [`USPS is closed for holidays. Jobs submitted today will be processed on the next business day.`],
    payment_failed: () =>
      isAdmin
        ? [
            'Your payment method has failed. We will not release your Certificates of Service until the issue is resolved. Click here to update information: ',
            <Link to="/settings?tab=billing">Organization Billing</Link>,
            '.',
          ]
        : [
            'Your payment method has failed. We will not release your Certificates of Service until the issue is resolved. Please contact your admin to update information.',
          ],
    invalid_method: () => [
      isAdmin
        ? 'No valid payment method. Update in Payment Information dropdown to submit job.'
        : 'No valid payment method. Contact admin to update payment information.',
    ],
  };

  const onBannerClose = () => {
    onClose();
    setIsClosed(true);
  };

  return isClosed ? null : (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        position: 'fixed',
        zIndex: 100,
        padding: '1rem',
        backgroundColor: bgColorByType[type],
      }}
    >
      <Typography
        sx={{ fontSize: '0.875rem', lineHeight: '1.25rem', fontWeight: 600, color: colorByType[type], textAlign: 'center' }}
      >
        {textByType[type]()}
      </Typography>
      <IconButton
        sx={{
          '&:hover': {
            borderRadius: 0,
          },
          '&:active': {
            borderRadius: 0,
          },
          position: 'fixed',
          right: '1rem',
          top: '0.5rem',
        }}
        size="small"
        onClick={onBannerClose}
      >
        <CloseIcon sx={{ color: '#45464F', height: '1.5rem', width: '1.5rem' }} />
      </IconButton>
    </Box>
  );
};
